import {FC} from 'react'
import {downloadTemplateSupplier, uploadMasiveSupplier} from '../../../../services'
import {ERROR_MESSAGE_SYSTEM} from '../../../../../../util/Constants'
import {ShowSnackBar} from '../../../../../../util/functions'
import {FormMasive} from '../../../../../../components/UI/Form/MasiveV2'
const MasiveUploadSupplier: FC = () => {
  const handleUpload = async (formData: FormData) => {
    try {
      const data = await uploadMasiveSupplier(formData) // Use the service to upload the file
      return data
    } catch (error) {
      ShowSnackBar(ERROR_MESSAGE_SYSTEM, 'error')
    }
  }
  return (
    <FormMasive
      serviceTemplate={downloadTemplateSupplier}
      handleSendService={handleUpload}
      textData1='Carga masiva de Proveedores:'
      textData='Carga masiva de Proovedores:'
      title='Proveedor'
    />
  )
}

export {MasiveUploadSupplier}
